import { ApiAgentRequest, request } from "../utils"
import { LanguageProficiencyFilesResource } from "@backend/agents-ui-api/resources/student-document/language-proficiency/types"

export type RawGetLanguageProficiencyFileResponse = {
  data: LanguageProficiencyFilesResource
}

export async function getLanguageProficiencyFile(studentId: string, languageProficiencyId: string) {
  return request<RawGetLanguageProficiencyFileResponse>(
    new ApiAgentRequest(`/students/${studentId}/language-proficiencies/${languageProficiencyId}/file`, {
      method: 'GET',
    }),
    {
      isExpectedResponse: (res): res is RawGetLanguageProficiencyFileResponse => res as boolean,
    },
  )
}